<script setup>

const docsStore = useDocsStore()
await docsStore.getList()

useSeoMeta({
    title: 'Документы',
})

</script>
<template>
    <section class="bg-brand-bright md:py-10 pt-0">
        <div class="container">
            <h1 class="text-2xl mb-6 text-brand-grey">Список документов</h1>
            <div class="grid grid-cols-1 md:grid-cols-4 gap-3 py-4">
                <template v-for="item in docsStore.items">
                    <div
                        class="max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                        <nuxt-link :to="`/docs/${item.id}`" class="cursor-pointer">
                            <div :style="{ backgroundImage: `url(/img/docs.jpg)` }"
                                class="w-full h-[220px] bg-no-repeat bg-center bg-cover"></div>
                        </nuxt-link>
                        <div class="px-5 mb-0 py-5">
                            <nuxt-link :to="`/docs/${item.id}`"
                                class="text-base cursor-pointer inline-block font-Montserrat font-semibold text-blue-900 md:text-ellipsis md:overflow-hidden overflow-auto">
                                {{ item.title }}
                            </nuxt-link>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>

</template>